import { render, staticRenderFns } from "./LineupPositionCard.vue?vue&type=template&id=6ac6595e&scoped=true&"
import script from "./LineupPositionCard.vue?vue&type=script&lang=ts&"
export * from "./LineupPositionCard.vue?vue&type=script&lang=ts&"
import style0 from "./LineupPositionCard.vue?vue&type=style&index=0&id=6ac6595e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac6595e",
  null
  
)

export default component.exports